export default {
  subtitle: "Colombian Bank Accounts",
  path: "bank_accounts_co",
  paragraphs: [
    "Your Colombian Bank Account will be available within your credentials and your Portal. You can always check it in Bank Accounts > FacilitaPay Payin accounts.",
    "To add your customer's bank account in Colombia, use the endpoint below. Replace :id with the subject_id:"
  ],
  request: {
    method: "POST",
    endpoint: "/subject/:id/bank_accounts",
    payload: {
      "bank_account": {
        "account_type": "poupanca",
        "account_number": "06553536",
        "branch_number": "0031",
        "owner_document_number": "9016404513",
        "owner_document_type": "cc",
        "owner_name": "Andrés Castillo",
        "branch_country": "COL",
        "bank": {
          "code": "1303",
          "name": "Banco Union"
        },
        "currency": "COP"
      }
    },
    responses: {
      "data": {
        "routing_number": null,
        "pix_info": null,
        "owner_name": "Andrés Castillo",
        "owner_document_number": "9016404513",
        "owner_document_type": "cc",
        "owner_company": {
          "social_name": "POWER HOME THEATER",
          "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
          "document_type": "tax_id",
          "document_number": "2348909854385"
        },
        "nickname": null,
        "intermediary_bank_account": null,
        "id": "76c82ab0-a0fb-4536-8c48-fe261e6d0b2d",
        "iban": null,
        "currency": "COP",
        "branch_number": "0031",
        "branch_country": "COL",
        "bank": {
          "swift": null,
          "name": "Banco Union",
          "ispb": null,
          "id": "d6870540-f347-4af6-b333-75b515ef5108",
          "country": "COL",
          "code": "1303"
        },
        "account_type": "poupanca",
        "account_number": "06553536",
        "aba": null
    }
  }
  },
  pathPayload: [
    {
      name: "id",
      type: "string",
      required: true,
      description: "A Colombian customer UUID"
    }
  ],
  parameterPayload: [
    {
      name: "bank_account",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },
     {
      name: "bank_account.account_number",
      type: "string",
      required: true,
      description: "Account number",
    },
    {
      name: "bank_account.branch_number",
      type: "string",
      required: true,
      description: "Account branch number",
    },
    {
      name: "bank_account.owner_name",
      type: "string",
      required: true,
      description: "Account owner full name",
    },
     {
      name: "bank_account.currency",
      type: "string",
      required: true,
      description: "Account currency. For Colombia, use 'COP'.",
    },
    {
      name: "bank_account.bank",
      type: "object",
      required: true,
      description: "An object containing information from the bank which the account belongs:",
      is_parent: true
    },
    {
      name: "bank_account.bank.name",
      type: "string",
      required: true,
      description: "Bank name",
    },
    {
      name: "bank_account.bank.code",
      type: "string",
      required: true,
      description: "Bank Code",
    },
    {
      name: "bank_account.account_type",
      type: "string",
      required: false,
      description: "Account type. In Colombia, they will be mapped as follows: Conta Corriente -> 'conta-corrente'; Cuenta de Ahorros -> 'poupanca'; Cuentas Nómina -> 'salary'; Cuentas pensionales -> 'payment'",
    },
    {
      name: "bank_account.owner_document_number",
      type: "string",
      required: false,
      description: "Document number for the account owner",
    },
    {
      name: "bank_account.owner_document_type",
      type: "string",
      required: false,
      description: "cc or nit (downcase)",
    },
    {
      name: "bank_account.branch_country",
      type: "String",
      required: false,
      description: "An ISO 3166-1 alpha-3 country code of the account country. For Colombia, use 'COL'.",
    }
  ],
  footerNotes: "¹CC and NIT are unique identification codes for Colombian citizens and companies, respectively, and are used to track tax information and other identification purposes by the government. They are analog to the SSN - Social Security Number ou CURP, for Mexico. ²If a previously registered bank code is provided, its corresponding name will be overwritten with the recorded in our database.",
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        description: 'Not providing currency',
        code: {
            "errors": {
                "currency": [
                    "can't be blank"
                ]
            }
        },
        solution: 'Provide a valid currency, in this case COP'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/BankAccount/BankAccountsRegistrationCO.js